const CATEGORIES = [
    'Home Services',
    'Cleaning',
    'Plumbing',
    'Electrical',
    'Moving & Delivery',
    'Beauty & Wellness',
    'Tutoring & Education',
    'IT & Tech Support',
    'Design & Creative',
    'Legal & Consulting',
    'Photography & Video',
    'Events & Entertainment',
    'Car Services',
    'Health & Fitness',
    'Other'
  ];
  
  module.exports = CATEGORIES;